import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { IAssignmentType, ICreateAssignmentTypeRequest } from '../models/assignment-type';

@Injectable({
  providedIn: 'root'
})
export class AssignmentTypeService {

  constructor(private http: HttpClient) { }

  searchAssignmentTypes(request: IBaseSearchRequest = { pageSize: 999999, pageNumber: 0 }) {
    return this.http.post<IPagedResults<IAssignmentType[]>>(
      `${environment.baseUrl}/v1/AssignmentType/searchAssignmentTypes`,
      request
    );
  }

  getAssignmentType(id: string) {
    return this.http.get<IAssignmentType>(
      `${environment.baseUrl}/v1/AssignmentType/getAssignmentType/${id}`
    );
  }

  createAssignmentType(request: ICreateAssignmentTypeRequest) {
    return this.http.post<string>(
      `${environment.baseUrl}/v1/AssignmentType/createAssignmentType`,
      request
    );
  }

  updateAssignmentType(request: IAssignmentType) {
    return this.http.put<string>(
      `${environment.baseUrl}/v1/AssignmentType/updateAssignmentType/${request.id}`,
      request
    );
  }

  deleteAssignmentType(id: string) {
    return this.http.delete<string>(
      `${environment.baseUrl}/v1/AssignmentType/deleteAssignmentType/${id}`
    );
  }
}
